module.exports = __webpack_public_path__ + "images/3.1788921444950.jpg";